import type { CourseSummary } from "../../content/lookup.ts";

const LEVEL_LABELS: Record<CourseSummary["level"], string> = {
  beginner: "Beginner",
  intermediate: "Intermediate",
};

/** A course's level as a small tag with a colored dot. */
export function LevelTag({ level }: { level: CourseSummary["level"] }) {
  return <span className={`level-tag level-${level}`}>{LEVEL_LABELS[level]}</span>;
}
